import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store/store';

import * as actions from '@redux-actions/';

type LoginErrorCallback = () => void;

const useLoginState = () => {
    const config = useSelector((state: RootState) => state.common.config);
    const isLoggedIn = useSelector((state: RootState) => state.common.isLoggedIn);

    const dispatch = useDispatch();

    const loginCallback = useCallback((success: boolean, errorCallback: LoginErrorCallback) => {
        dispatch(actions.setIsLoggedIn(success));

        if (success === false) {
            console.warn(`Attempt to login failed!`);
            errorCallback();
        }
    }, []);

    const login = useCallback(
        (errorCallback: LoginErrorCallback) => {
            const login = config?.login;

            try {
                if (!!login) {
                    login(success => loginCallback(success, errorCallback));
                } else {
                    console.warn('missing config.login!');
                }
            } catch (err) {
                console.error(err);
            }
        },
        [config, loginCallback]
    );

    return { isLoggedIn, login };
};

export default useLoginState;
